export enum PaymentTypeEnum {
  oneTime = 'one_time',
  recurring = 'recurring',
}

export enum RenewalPolicyEnum {
  autoRenewal = 'auto_renewal',
  cancelled = 'cancelled',
}

export enum PlanNameEnum {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}
